/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiServerExceptionResponse,
  ApiServerExceptionWithErrorCode,
  AvailableDomainsResponse,
  MemberAddRequest,
  PermissionAddRequest,
  SlugAvailability,
  SlugUpdateRequest,
  Workspace,
  WorkspaceCreateRequest,
  WorkspaceOptionsUpdateRequest,
  WorkspaceUpdateRequest,
} from '../models/index';
import {
    ApiServerExceptionResponseFromJSON,
    ApiServerExceptionResponseToJSON,
    ApiServerExceptionWithErrorCodeFromJSON,
    ApiServerExceptionWithErrorCodeToJSON,
    AvailableDomainsResponseFromJSON,
    AvailableDomainsResponseToJSON,
    MemberAddRequestFromJSON,
    MemberAddRequestToJSON,
    PermissionAddRequestFromJSON,
    PermissionAddRequestToJSON,
    SlugAvailabilityFromJSON,
    SlugAvailabilityToJSON,
    SlugUpdateRequestFromJSON,
    SlugUpdateRequestToJSON,
    WorkspaceFromJSON,
    WorkspaceToJSON,
    WorkspaceCreateRequestFromJSON,
    WorkspaceCreateRequestToJSON,
    WorkspaceOptionsUpdateRequestFromJSON,
    WorkspaceOptionsUpdateRequestToJSON,
    WorkspaceUpdateRequestFromJSON,
    WorkspaceUpdateRequestToJSON,
} from '../models/index';

export interface WorkspaceApiAddDomainRequest {
    workspaceId: string;
    domainId: string;
}

export interface WorkspaceApiAddDomainPermissionRequest {
    workspaceId: string;
    domainId: string;
    permissionAddRequest: PermissionAddRequest;
}

export interface WorkspaceApiAddMemberRequest {
    workspaceId: string;
    memberAddRequest: MemberAddRequest;
}

export interface WorkspaceApiCreateRequest {
    workspaceCreateRequest: WorkspaceCreateRequest;
}

export interface WorkspaceApiDeleteRequest {
    workspaceId: string;
}

export interface WorkspaceApiGetRequest {
    workspaceId: string;
}

export interface WorkspaceApiGetAvailableDomainsRequest {
    workspaceId: string;
}

export interface WorkspaceApiIsSlugAvailableRequest {
    slug: string;
}

export interface WorkspaceApiLeaveRequest {
    workspaceId: string;
}

export interface WorkspaceApiRemoveDomainRequest {
    workspaceId: string;
    domainId: string;
}

export interface WorkspaceApiRemoveDomainPermissionRequest {
    workspaceId: string;
    domainId: string;
    permissionId: string;
}

export interface WorkspaceApiRemoveMemberRequest {
    workspaceId: string;
    memberId: string;
}

export interface WorkspaceApiUpdateRequest {
    workspaceId: string;
    workspaceUpdateRequest: WorkspaceUpdateRequest;
}

export interface WorkspaceApiUpdateDomainOptionsRequest {
    workspaceId: string;
    domainId: string;
    workspaceOptionsUpdateRequest: WorkspaceOptionsUpdateRequest;
}

export interface WorkspaceApiUpdateSlugRequest {
    workspaceId: string;
    slugUpdateRequest: SlugUpdateRequest;
}

/**
 * 
 */
export class WorkspaceApi extends runtime.BaseAPI {

    /**
     * Add an existing `Domain` to an `Workspace`.
     */
    async addDomainRaw(requestParameters: WorkspaceApiAddDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling addDomain().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling addDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/domain/{domainId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Add an existing `Domain` to an `Workspace`.
     */
    async addDomain(requestParameters: WorkspaceApiAddDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.addDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add Permission to a Member for a Workspace.
     */
    async addDomainPermissionRaw(requestParameters: WorkspaceApiAddDomainPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling addDomainPermission().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling addDomainPermission().'
            );
        }

        if (requestParameters['permissionAddRequest'] == null) {
            throw new runtime.RequiredError(
                'permissionAddRequest',
                'Required parameter "permissionAddRequest" was null or undefined when calling addDomainPermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/domain/{domainId}/permissions`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PermissionAddRequestToJSON(requestParameters['permissionAddRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Add Permission to a Member for a Workspace.
     */
    async addDomainPermission(requestParameters: WorkspaceApiAddDomainPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.addDomainPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a (new) `User` as a Member to a Workspace.
     */
    async addMemberRaw(requestParameters: WorkspaceApiAddMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling addMember().'
            );
        }

        if (requestParameters['memberAddRequest'] == null) {
            throw new runtime.RequiredError(
                'memberAddRequest',
                'Required parameter "memberAddRequest" was null or undefined when calling addMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/members`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MemberAddRequestToJSON(requestParameters['memberAddRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Add a (new) `User` as a Member to a Workspace.
     */
    async addMember(requestParameters: WorkspaceApiAddMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.addMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a workspace with the current `User` as an Owner.
     * Create a workspace.
     */
    async createRaw(requestParameters: WorkspaceApiCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'workspaceCreateRequest',
                'Required parameter "workspaceCreateRequest" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkspaceCreateRequestToJSON(requestParameters['workspaceCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Create a workspace with the current `User` as an Owner.
     * Create a workspace.
     */
    async create(requestParameters: WorkspaceApiCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.createRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a Workspace. Only the owner of a Workspace can delete the Workspace.
     * Deletes a workspace.
     */
    async deleteRaw(requestParameters: WorkspaceApiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling delete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Deletes a Workspace. Only the owner of a Workspace can delete the Workspace.
     * Deletes a workspace.
     */
    async delete(requestParameters: WorkspaceApiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.deleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a single `Workspace` by ID
     */
    async getRaw(requestParameters: WorkspaceApiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Retrieve a single `Workspace` by ID
     */
    async get(requestParameters: WorkspaceApiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.getRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all workspaces for this user. Can be empty (can also be >1).
     * Retrieve all workspaces for this user.
     */
    async getAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Workspace>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkspaceFromJSON));
    }

    /**
     * Retrieve all workspaces for this user. Can be empty (can also be >1).
     * Retrieve all workspaces for this user.
     */
    async getAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Workspace>> {
        const response = await this.getAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * List all potentially available `Domain`s for an `Workspace`.
     */
    async getAvailableDomainsRaw(requestParameters: WorkspaceApiGetAvailableDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AvailableDomainsResponse>>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getAvailableDomains().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/domains/available`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AvailableDomainsResponseFromJSON));
    }

    /**
     * List all potentially available `Domain`s for an `Workspace`.
     */
    async getAvailableDomains(requestParameters: WorkspaceApiGetAvailableDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AvailableDomainsResponse>> {
        const response = await this.getAvailableDomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns whether the given slug can be used for a workspace.
     * Check if a workspace slug is available.
     */
    async isSlugAvailableRaw(requestParameters: WorkspaceApiIsSlugAvailableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SlugAvailability>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling isSlugAvailable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/slug/{slug}/available`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SlugAvailabilityFromJSON(jsonValue));
    }

    /**
     * Returns whether the given slug can be used for a workspace.
     * Check if a workspace slug is available.
     */
    async isSlugAvailable(requestParameters: WorkspaceApiIsSlugAvailableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SlugAvailability> {
        const response = await this.isSlugAvailableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Leave a Workspace. This is useful for an Agent, to remove themselves from a Workspace.
     */
    async leaveRaw(requestParameters: WorkspaceApiLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling leave().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/member/self`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Leave a Workspace. This is useful for an Agent, to remove themselves from a Workspace.
     */
    async leave(requestParameters: WorkspaceApiLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.leaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a `Domain` association from a `Workspace`.
     */
    async removeDomainRaw(requestParameters: WorkspaceApiRemoveDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling removeDomain().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling removeDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/domain/{domainId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Remove a `Domain` association from a `Workspace`.
     */
    async removeDomain(requestParameters: WorkspaceApiRemoveDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.removeDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove Permission from a Member for a Workspace.
     */
    async removeDomainPermissionRaw(requestParameters: WorkspaceApiRemoveDomainPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling removeDomainPermission().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling removeDomainPermission().'
            );
        }

        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling removeDomainPermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/domain/{domainId}/permission/{permissionId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"permissionId"}}`, encodeURIComponent(String(requestParameters['permissionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Remove Permission from a Member for a Workspace.
     */
    async removeDomainPermission(requestParameters: WorkspaceApiRemoveDomainPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.removeDomainPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a Member from a Workspace.
     */
    async removeMemberRaw(requestParameters: WorkspaceApiRemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling removeMember().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling removeMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/member/{memberId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Remove a Member from a Workspace.
     */
    async removeMember(requestParameters: WorkspaceApiRemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.removeMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Only updates a name and/or avatarUrl. Only the owner of a Workspace can update the Workspace.
     * Update a workspace.
     */
    async updateRaw(requestParameters: WorkspaceApiUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling update().'
            );
        }

        if (requestParameters['workspaceUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'workspaceUpdateRequest',
                'Required parameter "workspaceUpdateRequest" was null or undefined when calling update().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: WorkspaceUpdateRequestToJSON(requestParameters['workspaceUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Only updates a name and/or avatarUrl. Only the owner of a Workspace can update the Workspace.
     * Update a workspace.
     */
    async update(requestParameters: WorkspaceApiUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.updateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modify the options on a Domain for a Workspace.
     */
    async updateDomainOptionsRaw(requestParameters: WorkspaceApiUpdateDomainOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateDomainOptions().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling updateDomainOptions().'
            );
        }

        if (requestParameters['workspaceOptionsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'workspaceOptionsUpdateRequest',
                'Required parameter "workspaceOptionsUpdateRequest" was null or undefined when calling updateDomainOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/domain/{domainId}/options`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: WorkspaceOptionsUpdateRequestToJSON(requestParameters['workspaceOptionsUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Modify the options on a Domain for a Workspace.
     */
    async updateDomainOptions(requestParameters: WorkspaceApiUpdateDomainOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.updateDomainOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the slug of a workspace. The slug must be in valid slug format and globally unique. Only the owner of a Workspace can update the slug.
     * Update the slug of a workspace.
     */
    async updateSlugRaw(requestParameters: WorkspaceApiUpdateSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateSlug().'
            );
        }

        if (requestParameters['slugUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'slugUpdateRequest',
                'Required parameter "slugUpdateRequest" was null or undefined when calling updateSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/workspace/{workspaceId}/slug`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SlugUpdateRequestToJSON(requestParameters['slugUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Updates the slug of a workspace. The slug must be in valid slug format and globally unique. Only the owner of a Workspace can update the slug.
     * Update the slug of a workspace.
     */
    async updateSlug(requestParameters: WorkspaceApiUpdateSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.updateSlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
